import axios from '~/utils/axios';

export type IntegrationApiIdentityType = {
  id: string;
  solutionId: string;
  partnerId: string;
  tokenPrefix: string;
  actions: string[];
  ipAddresses?: string[];
  createdAt: string;
};

export type CreatedIntegrationApiIdentityType = {
  identity: IntegrationApiIdentityType;
  token: string;
};

export const getIntegrationApiIdentity = (id: string) => {
  return axios.get<IntegrationApiIdentityType>(`/partners/${id}/identity`);
};

export const createIntegrationApiIdentity = (partnerId: string) => {
  return axios.post<CreatedIntegrationApiIdentityType>(`partners/${partnerId}/identity/reset`);
};

export const updateIntegrationApiIdentity = (props: { partnerId: string; data: any }) => {
  const { partnerId, data } = props;
  return axios.put<IntegrationApiIdentityType>(`partners/${partnerId}/identity/actions`, data);
};

export const updateIntegrationApiIdentityIpAddresses = (props: {
  partnerId: string;
  ipAddresses: string;
}) => {
  return axios.put<IntegrationApiIdentityType>(`partners/${props.partnerId}/identity/ipAddresses`, {
    ipAddresses: props.ipAddresses,
  });
};

export const getPartner = (id: string) => {
  return axios.get<void>(`/partners/${id}`);
};

export const getPartnerByExternalId = (externalId: string) => {
  return axios.get<void>(`/partners/byExternalId/${externalId}`);
};

export const closePartner = (id: string) => {
  return axios.post<void>(`/partners/${id}/close`);
};

export const getPartnerConfiguration = (partnerId: string) => {
  return axios.get<any>(`/partners/${partnerId}/configuration`);
};

export const setPartnerConfiguration = (partnerId: string, configuration: any) => {
  return axios.put<any>(`/partners/${partnerId}/configuration`, configuration);
};

export type IntegrationIdentityAction = {
  key: string;
  name: string;
};

export const listIdentityActions = (partnerId: string) => {
  return axios.get<IntegrationIdentityAction[]>(`/partners/${partnerId}/identity/actions`);
};

export const getIdentityRates = (partnerId: string) => {
  return axios.get<any>(`/partners/${partnerId}/identity/rates`);
};

export const setIdentityRates = (props: { partnerId: string; configuration: any }) => {
  return axios.put<any>(`/partners/${props.partnerId}/identity/rates`, props.configuration);
};
